<template>
  <div :class="computedClass" class="badge">{{ text }}</div>
</template>

<script>
export default {
  name: "Badge",
  props: {
    text: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: "default",
    },
  },
  computed: {
    computedClass() {
      let result;
      switch (this.variant) {
        case "green":
          result = "text-success border-success";
          break;
        case "disabled":
          result = "text-gray-500 bg-gray-200 border-0";
          break;
        case "orange":
          result = "text-warning border-warning";
          break;
        case "red":
          result = "text-danger border-danger";
          break;
        case "ghost":
          result = "text-gray-600 border-0";
          break;
        default:
          result = "text-gray-600 border-gray-300";
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.badge {
  font-weight: $font-weight-bold;
  font-size: $font-size-sm;
  padding: $spacer / 6 $spacer / 4;
  line-height: 1;
  border-radius: $border-radius;
  border: $width-border-thin solid $gray-500;
  text-transform: uppercase;
}
</style>
